import React, { useState, useEffect } from 'react';
import "bootstrap-icons/font/bootstrap-icons.css";
import AOS from "aos";
import "aos/dist/aos.css";
 import { Helmet } from "react-helmet-async";
 
const AboutUs = () => {
  const phrases = [
    "About Us  ",
    "Affsoft IT Solutions Pvt. Ltd."  
  ];

  const cardData = [
    { type: 'purple-clay', content: '🔮' },
    { type: 'smooth-wave', content: '🧬' },
    { type: 'abstract-blocks', content: '📊' },
    { type: 'pink-sphere', content: '⚪' }
  ];

  // State Management
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [cardIndex, setCardIndex] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  // Initialize AOS and Parallax Event Listener
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Typing Effect Logic
  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];
    let timer;

    const handleTyping = () => {
      if (!isDeleting) {
        setDisplayedText(currentPhrase.substring(0, displayedText.length + 1));
        if (displayedText === currentPhrase) {
          timer = setTimeout(() => setIsDeleting(true), 1600);
          return;
        }
      } else {
        setDisplayedText(currentPhrase.substring(0, displayedText.length - 1));
        if (displayedText === '') {
          setIsDeleting(false);
          setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
          return;
        }
      }

      const speed = isDeleting ? 30 : 80;
      timer = setTimeout(handleTyping, speed);
    };

    timer = setTimeout(handleTyping, 100);
    return () => clearTimeout(timer);
  }, [displayedText, isDeleting, currentPhraseIndex]);

  // Card Content Rotation Logic
  useEffect(() => {
    const cardTimer = setInterval(() => {
      setCardIndex((prev) => (prev + 1) % cardData.length);
    }, 1100);
    return () => clearInterval(cardTimer);
  }, []);

  return (
    
    <>

   

      <Helmet>
        {/* Primary SEO */}
        <title>About Us | Affsoft IT Solutions Pvt. Ltd.</title>

        <meta
          name="title"
          content="About Us | Affsoft IT Solutions Pvt. Ltd."
        />

        <meta
          name="description"
          content="Learn more about Affsoft IT Solutions Pvt. Ltd., a trusted IT services company delivering innovative software development, web design, web development, mobile applications, enterprise solutions, SAP, Oracle, Power BI, cloud solutions, AI, and digital transformation services."
        />

        <meta
          name="keywords"
          content="About Affsoft, Affsoft IT Solutions Pvt. Ltd., IT Company, Software Development Company, Web Development Company, Web Design Company, Mobile App Development, React JS, Node JS, MERN Stack, Enterprise Solutions, SAP, Oracle, Power BI, Cloud Solutions, AI Solutions, Digital Transformation, IT Consulting"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Affsoft IT Solutions Pvt. Ltd." />
        <meta name="language" content="English" />
        <meta name="theme-color" content="#0d5c53" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.affsoft.com/about-us" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Affsoft IT Solutions Pvt. Ltd." />
        <meta
          property="og:title"
          content="About Affsoft IT Solutions Pvt. Ltd."
        />
        <meta
          property="og:description"
          content="Discover Affsoft IT Solutions Pvt. Ltd., our expertise, mission, vision, and commitment to delivering world-class software development, digital transformation, and enterprise IT solutions."
        />
        <meta
          property="og:url"
          content="https://www.affsoft.com/about-us"
        />
        <meta
          property="og:image"
          content="https://www.affsoft.com/images/affsoft-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Us | Affsoft IT Solutions Pvt. Ltd."
        />
        <meta
          name="twitter:description"
          content="Learn about Affsoft IT Solutions Pvt. Ltd., our experienced team, innovative technologies, and commitment to delivering reliable IT solutions for businesses worldwide."
        />
        <meta
          name="twitter:image"
          content="https://www.affsoft.com/images/affsoft-logo.png"
        />
      </Helmet>
      {/* Custom Styles Injection to handle parallax performance & keyframes smoothly */}
      <style>{`
        .parallax-hero {
          transform: translateY(${scrollY * 0.15}px);
          transition: transform 0.1s linear;
        }
        .parallax-bg-element {
          transform: translateY(${scrollY * 0.08}px);
        }
        .btn-nimo {
          transition: all 0.3s ease;
        }
        .btn-nimo:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(255,255,255,0.15);
        }
        .btn-nimo:hover .arrow-circle {
          transform: translateX(4px);
        }
        .arrow-circle {
          transition: transform 0.3s ease;
        }
        .asterisk-icon {
          animation: spin 8s linear infinite;
        }
        .about-card, .card {
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
        .about-card:hover, .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
        }
        .counter-box h2 {
          transition: transform 0.3s ease;
        }
        .counter-box:hover h2 {
          transform: scale(1.1);
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      <div 
        className="hero-container container-fluid d-flex align-items-center justify-content-center position-relative overflow-hidden" 
        style={{ 
          backgroundImage: "url('./images/home.jpg')",
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed' // Traditional CSS Parallax Fallback
        }}
      >
        
        {/* Background Grid System with Running Line Tracer Animations */}
        <div className="grid-overlay position-absolute top-0 start-0 w-100 h-100 parallax-bg-element">
          <div className="grid-line line-v-1"></div>
          <div className="grid-line line-v-2"></div>
          <div className="grid-line line-v-3"></div>
        </div>

        {/* Infinite Slow-Scrolling Marquee Text Background Wrapper */}
        <div className="marquee-wrapper select-none position-absolute w-100">
          <div className="marquee-content text-white">
            <span>About Us &nbsp;&nbsp;|&nbsp;&nbsp; Affsoft IT Solutions Pvt. Ltd. &nbsp;&nbsp;&bull;&nbsp;&nbsp;</span>
            <span>About Us &nbsp;&nbsp;|&nbsp;&nbsp; Affsoft IT Solutions Pvt. Ltd. &nbsp;&nbsp;&bull;&nbsp;&nbsp;</span>
          </div>
        </div>

        {/* Main Content Layout */}
        <div className="row w-100 max-content-width align-items-start position-relative z-3 parallax-hero">
          
          {/* Left Side Info */}
          <div className="col-12 col-md-4 text-start pt-4 d-flex flex-column align-items-start hero-left-pane">
            <div className="asterisk-icon mb-3" style={{ fontSize: 28, display: 'inline-block', color: '#fff' }}>✳</div>
            <h5 className="tagline mb-4 text-white" style={{ fontSize: 18, lineHeight: '1.6' }}>
              At Affsoft IT Solutions Pvt. Ltd., we create modern, responsive, and high-performing websites that help businesses establish a strong online presence. Our web design and development services combine creativity, technology, and user experience to deliver websites that not only look exceptional but also generate leads and drive business growth.
            </h5>
            <button className="btn-nimo d-flex align-items-center gap-2 border border-white bg-transparent py-2 px-4 rounded-pill">
              <span className="arrow-circle text-white">➔</span>
              <span className="text-white fw-semibold">About Affsoft</span>
            </button>
          </div>

          {/* Center Section */}
          <div className="col-12 col-md-5 text-center pt-4 hero-center-pane">
            <div className="typing-badge px-4 py-2 mx-auto" style={{ background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(10px)', borderRadius: '30px' }}>
              <span className="typed-text text-white fw-bold">{displayedText}</span>
              <span className="cursor text-white animate-pulse">|</span>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-12 col-md-3 d-flex justify-content-end pt-4 hero-right-pane">
            <div className="glass-card-frame shadow-lg p-2" style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(12px)', borderRadius: '16px', transition: 'transform 0.3s ease' }}>
              <div className={`inner-graphic-card graphic-${cardData[cardIndex].type} d-flex align-items-center justify-content-center`} style={{ width: '120px', height: '120px', borderRadius: '12px', transition: 'all 0.5s ease' }}>
                <span className="graphic-icon" style={{ fontSize: '2.5rem' }}>{cardData[cardIndex].content}</span>
              </div>
            </div>
          </div>

        </div>
        
      </div>

      {/* ================= About Content ================= */}

      <section className="about-section py-5 position-relative overflow-hidden">
        <div className="container">

          <div className="text-center mb-5" data-aos="fade-up">
            <span className="section-tag text-primary fw-bold tracking-wider uppercase" style={{ letterSpacing: '2px' }}>WHO WE ARE</span>
            <h2 className="display-5 fw-bold mt-3">
                About | Affsoft IT Solutions Pvt. Ltd. 
            </h2>

          
            <p className="text-muted col-lg-9 mx-auto">
                Affsoft IT Solutions Pvt. Ltd. is a trusted global technology company delivering innovative IT consulting, software development, cloud solutions, and digital transformation services. We help startups, small and medium-sized businesses, and enterprises accelerate growth through modern technology, automation, and scalable digital solutions.
            </p>

              <p className="text-muted col-lg-9 mx-auto">
                Our mission is to simplify complex business challenges with intelligent technology. From custom software development to enterprise cloud solutions, our experienced professionals deliver secure, high-performance, and future-ready applications that drive measurable business results.
            </p>
          </div>

           
         

          <div className="row align-items-center mt-5">

            <div className="col-lg-6" data-aos="fade-right">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg dynamic-hover-img">
                <img
                  src="./images/affsoft-logo.png" width={100}
                  className="img-fluid w-100 transform transition duration-500 hover:scale-105"
                  alt="About Affsoft"
                />
              </div>
            </div>

            <div className="col-lg-6 ps-lg-5" data-aos="fade-left">
              <h2 className="fw-bold mb-4">
                Why Businesses Choose Affsoft?
              </h2>

              <p className="text-muted">
                We combine industry expertise, innovation,
                and cutting-edge technologies to deliver
                secure, scalable, and business-driven
                solutions. Our customer-first approach
                helps organizations accelerate digital
                transformation while reducing operational
                costs.
              </p>

              <div className="row mt-4">
                <div className="col-6 mb-3">
                  <div className="feature-box d-flex align-items-center gap-2 fw-medium">
                    <i className="bi bi-check-circle-fill text-success"></i>
                    Experienced Team
                  </div>
                </div>

                <div className="col-6 mb-3">
                  <div className="feature-box d-flex align-items-center gap-2 fw-medium">
                    <i className="bi bi-lightning-charge-fill text-warning"></i>
                    Fast Delivery
                  </div>
                </div>

                <div className="col-6 mb-3">
                  <div className="feature-box d-flex align-items-center gap-2 fw-medium">
                    <i className="bi bi-shield-check text-primary"></i>
                    Secure Solutions
                  </div>
                </div>

                <div className="col-6 mb-3">
                  <div className="feature-box d-flex align-items-center gap-2 fw-medium">
                    <i className="bi bi-headset text-info"></i>
                    24×7 Support
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="row mt-5 text-center g-4">

            <div className="col-6 col-md-3" data-aos="flip-left">
              <div className="counter-box p-4 border rounded-3 bg-light">
                <h2 className="fw-bold text-primary display-6">100+</h2>
                <p className="text-muted mb-0">Projects Delivered</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="flip-left" data-aos-delay="100">
              <div className="counter-box p-4 border rounded-3 bg-light">
                <h2 className="fw-bold text-success display-6">50+</h2>
                <p className="text-muted mb-0">Happy Clients</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="flip-left" data-aos-delay="200">
              <div className="counter-box p-4 border rounded-3 bg-light">
                <h2 className="fw-bold text-warning display-6">15+</h2>
                <p className="text-muted mb-0">Technology Expertise</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="flip-left" data-aos-delay="300">
              <div className="counter-box p-4 border rounded-3 bg-light">
                <h2 className="fw-bold text-danger display-6">99%</h2>
                <p className="text-muted mb-0">Client Satisfaction</p>
              </div>
            </div>

          </div>

        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="fw-bold mb-4">Driving Innovation. Delivering Excellence. Transforming Businesses.</h2>
            <p><strong>Affsoft IT Solutions Pvt. Ltd.</strong> is a leading global IT consulting and digital transformation company committed to helping businesses innovate, modernize, and grow through cutting-edge technology solutions. We specialize in delivering end-to-end IT services that enable organizations to improve operational efficiency, enhance customer experiences, and achieve sustainable business growth.</p>
            <p>In today's rapidly evolving digital landscape, organizations require more than just technology—they need a strategic partner capable of understanding their business challenges and delivering scalable, future-ready solutions. Our team delivers custom software development, web design and development, mobile app development, digital marketing, Power BI services, ServiceNow development, infrastructure development, application development, cloud migration, data integration, product engineering, AI & ML, enterprise cloud, SAP, Salesforce, Oracle, Microsoft and AWS solutions.</p>
            
            <h3 className="mt-5 fw-bold">Our Story</h3>
            <p>Affsoft IT Solutions Pvt. Ltd. was founded with a vision to make advanced technology accessible, practical, and impactful for businesses of every size. Since our inception, we have partnered with startups, growing businesses, and global enterprises to solve complex challenges through intelligent software, automation, analytics, and cloud technologies.</p>
            
            <h3 className="mt-5 fw-bold">Our Story</h3>
            <p>Affsoft IT Solutions Pvt. Ltd. was founded with a simple vision—to make advanced technology accessible, practical, and impactful for businesses of all sizes.</p>
            <p>Since our inception, we have partnered with startups, growing businesses, and global enterprises to solve complex business challenges through intelligent software solutions, cloud technologies, enterprise applications, automation, and digital transformation strategies.</p>
            <p>Today, we continue to expand our expertise across multiple industries while embracing emerging technologies such as Artificial Intelligence, Machine Learning, Robotic Process Automation, Cloud Computing, Big Data Analytics, Internet of Things, and Enterprise Digital Platforms.</p>

            <h3 className="mt-5 fw-bold">What We Do</h3>
            <p className="text-muted">We deliver comprehensive technology solutions designed to accelerate digital transformation and create measurable business value.</p>

            <div className="row g-4 mt-3">
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-terminal text-primary"></i> Custom Software Development</h5>
                    <p className="text-muted small">We build secure, scalable, and high-performance software applications that streamline business processes and improve productivity. Our custom development services include enterprise applications, business automation systems, CRM solutions, ERP integrations, SaaS platforms, and cloud-native applications.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-window-sidebar text-success"></i> Web Design and Development</h5>
                    <p className="text-muted small">Our Web Design and Development team creates responsive, SEO-friendly, and high-performance websites that deliver exceptional user experiences. Whether you need a corporate website, eCommerce platform, customer portal, or enterprise web application, we develop solutions optimized for speed, security, and scalability.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-phone text-info"></i> Mobile App Development</h5>
                    <p className="text-muted small">Our Mobile App Development services cover Android, iOS, Flutter, and React Native applications. We design intuitive, feature-rich mobile experiences that increase customer engagement, streamline business operations, and support digital innovation.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-graph-up-arrow text-danger"></i> Digital Marketing</h5>
                    <p className="text-muted small">Technology alone isn't enough—visibility matters. Our Digital Marketing experts help businesses grow through SEO, Local SEO, Social Media Marketing, PPC Campaigns, Content Marketing, Email Marketing, Online Reputation Management, and Conversion Rate Optimization. Our goal is to increase your online presence, generate qualified leads, and maximize return on investment.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-bar-chart-line text-warning"></i> Power BI Services</h5>
                    <p className="text-muted small">We help organizations unlock the power of their data through advanced Power BI Services. Our business intelligence experts create interactive dashboards, executive reports, predictive analytics, and real-time business insights that support informed decision-making.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-gear-wide-connected text-secondary"></i> ServiceNow Development</h5>
                    <p className="text-muted small">Our ServiceNow Development specialists automate enterprise workflows, improve IT service management, and streamline business operations using customized ServiceNow solutions.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-hdd-network text-dark"></i> Infrastructure Development</h5>
                    <p className="text-muted small">Modern businesses require reliable infrastructure. Our Infrastructure Development services include network architecture, virtualization, server management, cybersecurity implementation, infrastructure monitoring, and IT modernization.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-layers text-primary"></i> Application Development</h5>
                    <p className="text-muted small">We develop enterprise-grade applications using modern technologies including .NET, Java, Python, Node.js, React, Angular, Vue.js, and cloud-native architectures. Our application development process follows Agile methodologies, ensuring flexibility, transparency, and faster delivery.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-cloud-check text-success"></i> Cloud Migration</h5>
                    <p className="text-muted small">Cloud transformation is essential for digital success. We provide complete Cloud Migration services across AWS, Microsoft Azure, Oracle Cloud, and Google Cloud Platform. Our cloud experts help organizations migrate applications securely while improving scalability, availability, and operational efficiency.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-shuffle text-info"></i> Data Integration</h5>
                    <p className="text-muted small">Our Data Integration services enable businesses to connect enterprise applications, cloud platforms, databases, APIs, ERP systems, CRM solutions, and analytics platforms for seamless information exchange.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm border-0 bg-light p-2">
                  <div className="card-body">
                    <h5 className="fw-bold d-flex align-items-center gap-2"><i className="bi bi-boxes text-danger"></i> Product Engineering</h5>
                    <p className="text-muted small">We help organizations design, develop, modernize, and maintain innovative digital products from concept to deployment. Our Product Engineering team focuses on quality, performance, scalability, security, and continuous innovation.</p>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="mt-5 fw-bold">Digital Transformation</h3>
            <p>Our expertise includes Customer Experience & CPQ, Supply Chain Optimization, Big Data & Analytics, Mobility & UX, Artificial Intelligence, Machine Learning, Robotic Process Automation, Internet of Things, Human Capital Management, and Enterprise Digital Strategy.</p>
            
            <h3 className="mt-5 fw-bold">Mission & Vision</h3>
            <p>Our mission is to empower organizations with innovative technology solutions that accelerate digital transformation, improve operational efficiency, and drive sustainable business growth. Our vision is to become one of the world's most trusted technology partners through innovation, quality, integrity, and customer success.</p>
            
            <h3 className="mt-5 fw-bold">Development Process</h3>
            <ol className="list-group list-group-numbered border-0 rounded-0 max-content-width">
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-search me-2 text-primary"></i> Business Discovery & Consultation</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-clipboard-data me-2 text-success"></i> Requirement Analysis</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-diagram-3 me-2 text-info"></i> Solution Architecture</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-palette me-2 text-warning"></i> UI/UX Design</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-kanban me-2 text-danger"></i> Agile Development</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-patch-check me-2 text-secondary"></i> Quality Assurance & Testing</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-cloud-upload me-2 text-dark"></i> Deployment & Cloud Migration</li>
              <li className="list-group-item border-0 bg-transparent py-2"><i className="bi bi-tools me-2 text-primary"></i> Ongoing Maintenance & Technical Support</li>
            </ol>
            
            <h3 className="mt-5 fw-bold">Let's Build the Future Together</h3>
            <p>Whether you need Web Design and Development, Mobile App Development, Digital Marketing, Power BI Services, ServiceNow Development, Cloud Migration, Data Integration, SAP Enterprise Systems, Salesforce Platforms, Microsoft Cloud Solutions, AWS Cloud Solutions, AI & Machine Learning, or complete Digital Transformation Services, Affsoft IT Solutions Pvt. Ltd. is your trusted technology partner.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;